import { Dialog } from '@mui/material'
import { styled } from '@mui/material/styles'

export const StyledDialog = styled(Dialog)(() => ({
  '.MuiPaper-root': {
    borderRadius: '10px'
  }
}))
